import * as React from 'react';

import { ElementInViewport } from '../../common/components/element_in_viewport';
import { PopularPlaces } from '../../components/PopularPlaces';
import { trackPlacesShow } from './tracking';
import { usePopularPlaces } from './usePopularPlaces';

export const PopularPlacesContainer: React.VFC = () => {
  const { places, onPlaceClick } = usePopularPlaces();

  if (!places.length) {
    return null;
  }

  return (
    <ElementInViewport
      onChange={isVisible => {
        if (isVisible) {
          trackPlacesShow();
        }
      }}
    >
      <PopularPlaces places={places} onPlaceClick={onPlaceClick} />
    </ElementInViewport>
  );
};
